import React, { useState } from 'react';
import { Plus, Send, Loader2 } from 'lucide-react';
import api from '../utils/api';
import { DictationButton } from './DictationButton';

/**
 * Inline "Add your own ritual" form, used inside each Rituals category dropdown.
 * Creates a custom mission tagged with the category and source="custom".
 */
const AddYourOwnRitual = ({ category, language, onAdded }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!text.trim() || submitting) return;
    setSubmitting(true);
    try {
      await api.post('/missions', {
        title: text.trim(),
        category,
        source: `custom_ritual_${category}`,
        frequency: 'daily',
      });
      setText('');
      setOpen(false);
      onAdded?.();
    } catch (e) {
      // silently fail; user can retry
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className="w-full mt-2 p-3 rounded-xl border border-dashed border-white/15 text-[#A1A1AA] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-all flex items-center justify-center gap-2 text-sm font-sans"
        data-testid={`add-own-ritual-${category}`}
      >
        <Plus className="w-4 h-4" />
        {language === 'tr' ? 'Kendi pratiğini ekle' : 'Add your own'}
      </button>
    );
  }

  return (
    <div className="mt-2 p-3 rounded-xl border border-[#D4AF37]/30 bg-black/30" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center gap-2">
        <input
          autoFocus
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
          placeholder={language === 'tr' ? 'Kendi pratiğini yaz...' : 'Write your own practice...'}
          className="flex-1 bg-transparent text-[#F8F5F2] font-sans text-sm focus-visible:outline-none placeholder-[#6B7280]"
          data-testid={`add-own-ritual-input-${category}`}
        />
        <DictationButton onTranscript={(t) => setText(text + (text ? ' ' : '') + t)} />
        <button
          onClick={handleSubmit}
          disabled={!text.trim() || submitting}
          className="p-2 rounded-lg bg-[#D4AF37]/15 text-[#D4AF37] hover:bg-[#D4AF37]/25 transition-all disabled:opacity-40"
          data-testid={`add-own-ritual-submit-${category}`}
        >
          {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </button>
        <button
          onClick={() => { setOpen(false); setText(''); }}
          className="text-[#6B7280] text-xs px-2 hover:text-white"
          data-testid={`add-own-ritual-cancel-${category}`}
        >
          {language === 'tr' ? 'İptal' : 'Cancel'}
        </button>
      </div>
    </div>
  );
};

export default AddYourOwnRitual;
